import { useState } from "react";
import { faqItems } from "@/mocks/homeContent";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full border-b border-background-200 bg-background-100">
      <div className="grid w-full grid-cols-1 gap-10 px-4 py-12 md:px-8 md:py-20 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <p className="font-label text-[11px] uppercase tracking-[0.34em] text-accent-700">Q&amp;A · 常见问题</p>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            你最想问的，先替你答
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            五个问题覆盖了绝大多数反馈，读完基本能自己判断，不必再到处打听。
          </p>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 border-y border-background-200">
            {faqItems.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left"
                  >
                    <span className="font-heading text-base font-semibold leading-snug text-foreground-900 md:text-lg">
                      {f.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                        isOpen
                          ? "border-primary-300 bg-primary-100 text-primary-700"
                          : "border-background-300 text-foreground-600"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="animate-fade-up pb-6 pr-0 text-sm leading-relaxed text-foreground-600 md:pr-12">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}